export default {
    template: `
                <div class="pure-u-1-4 pure-u-md-1-8 img-box">
                    <img class="pure-img" :src="image" alt="">
                </div>
                <div class="pure-u-3-4 pure-u-md-3-8 title">
                    <div>{{product_name}}</div>
                    <div v-if="characteristics?.length">
                        <span v-for="characteristic in characteristics" :key="characteristic.type_id" v-text="characteristic.value"></span>
                    </div>
                </div>
                <div class="d-none d-md-block pure-u-md-1-8 text-end">{{price}} ${currency}</div>
                 <div class="sizes pure-u-1 pure-u-md-3-8 text-end" v-if="showVariants && enableChangeMode">
                    <template v-for="variant in variants" :key="variant.product_variant_id" >
                         <button class="size-box" :class="{'size-current':isCurrentVariant(variant),'disabled':variant.stock < 1}" :disabled="variant.stock < 1" @click="changeVariant(variant)">
                             <span v-for="characteristic in variant.characteristics" :key="characteristic.type_id" v-text="characteristic.value"></span>
                        </button>
                   </template>
                </div>
                <div v-if="showButtons === false" class="pure-u-1-4 text-center qu"></div>
                 <div v-else-if="!(showVariants && enableChangeMode)" class="pure-u-1-4 text-center qu">
                    <div v-if="enableAddMode || enableChangeMode">
                        <button class="btn btn-round" v-on:click="modifyQuantity(-1)">-</button>
                        <span class="mx-3">{{qty}}</span>
                        <button class="btn btn-round" v-on:click="modifyQuantity(1)">+</button>
                    </div>
                    <div v-else-if="qty > 1">
                        <button class="btn btn-round" v-on:click="modifyQuantity(-1)">-</button>
                        <span class="mx-3">{{qty}}</span>
                    </div>
                    <div v-else="qty > 1">
                        <span class="mx-3 d-none d-md-block">{{qty}}</span>
                    </div>
                    <div>
                        <button class="btn btn-secondary" v-on:click="remove(orderItemIndex)">${langhelp.cart.remove}</button>
                    </div>
                </div>
                <div v-if="!(enableAddMode && enableChangeMode)" class="pure-u-1-4 pure-u-md-1-8 text-end price"><template v-if="qty == 0">-</template>{{price}} ${currency}</div>
                 <div v-else-if="!(showVariants && enableChangeMode)" class="pure-u-1-4 pure-u-md-1-8 text-end price">{{overallTotal}} ${currency}</div>
            `,
    props: ["product_name","image","qty","price","serial","characteristics","orderItemIndex","showButtons","variants","product_variant_id","enableAddMode","enableChangeMode"],
    computed:{
        overallTotal(){
            return this.price * this.qty;
        },
        showVariants(){
            return !!(this.variants && this.variants.length);
        }
    },
    methods:{
        remove(){
            this.$emit('remove-product',this.orderItemIndex)
        },
        modifyQuantity(qty){
            this.$emit('modify-qty',{orderItemIndex:this.orderItemIndex,qty})
        },
        changeVariant(variant){
            this.$emit('change-variant',{
                orderItemIndex:this.orderItemIndex,
                remove_pvId:this.product_variant_id,
                change_pvId:variant.product_variant_id,
                characteristics:variant.characteristics ?? [],
                qty:this.qty
            })
        },
        isCurrentVariant(variant){
            return variant.characteristics?.some((characteristic) => characteristic.is_current);
        }
    }
};
